<section class="gateway-monitor" *ngIf="location">
    <div class="gateway-state loading" *ngIf="loading">
        <span class="gateway-loader" aria-hidden="true"></span>
        <div>
            <strong>Cargando datos del gateway</strong>
            <small>Consultando lecturas y último dato disponible...</small>
        </div>
    </div>

    <div class="gateway-state error" *ngIf="!loading && loadError">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <div>
            <strong>No fue posible cargar el gateway</strong>
            <small>Intenta nuevamente en unos momentos.</small>
        </div>
        <button type="button" (click)="selectDevice(selectedDevice)">Reintentar</button>
    </div>

    <ng-container *ngIf="!loading && !loadError">
        <header class="gateway-summary">
            <span class="gateway-avatar"><i class="fa fa-cloud" aria-hidden="true"></i></span>
            <div class="gateway-identity">
                <small>{{ deviceTypeName }} monitoreado</small>
                <h2>{{ deviceDescription }}</h2>
                <p><i class="fa fa-map-marker" aria-hidden="true"></i>{{ location.name || 'Ubicación sin nombre' }}</p>
            </div>
            <span class="gateway-status" [class.has-data]="sensorList.length">
                <i class="fa" [ngClass]="sensorList.length ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
                {{ sensorList.length ? 'Conectado' : 'Sin datos' }}
            </span>
        </header>

        <div class="gateway-metrics">
            <article>
                <span>Tipo</span>
                <strong>{{ deviceTypeName }}</strong>
                <small>Clasificación del activo</small>
            </article>
            <article>
                <span>Dispositivo</span>
                <strong>{{ deviceIdentifier }}</strong>
                <small>Identificador del gateway</small>
            </article>
            <article>
                <span>Último dato</span>
                <strong>{{ latestReading?.ts || 'Sin datos' }}</strong>
                <small>Última comunicación</small>
            </article>
            <article>
                <span>Lecturas</span>
                <strong>{{ sensorList.length }}</strong>
                <small>Valores recibidos</small>
            </article>
        </div>

        <section class="gateway-panel">
            <div class="gateway-panel-heading">
                <div>
                    <h3>Datos actuales</h3>
                    <p>Últimas lecturas reportadas por el gateway.</p>
                </div>
                <span>{{ sensorList.length }} lectura{{ sensorList.length === 1 ? '' : 's' }}</span>
            </div>

            <div class="gateway-readings" *ngIf="sensorList.length; else noGatewayData">
                <div class="gateway-reading" *ngFor="let sensor of sensorList">
                    <span class="reading-date">{{ sensor.ts }}</span>
                    <span class="reading-name">{{ sensor.name }}</span>
                    <strong>{{ sensor.value }}</strong>
                    <i [class.ok]="sensor.value !== null && sensor.value !== undefined" aria-hidden="true"></i>
                </div>
            </div>
            <ng-template #noGatewayData>
                <div class="gateway-empty">
                    <i class="fa fa-database" aria-hidden="true"></i>
                    <strong>Sin datos disponibles</strong>
                    <small>El gateway aún no ha reportado lecturas.</small>
                </div>
            </ng-template>
        </section>
    </ng-container>
</section>
